export const numberParser = (figure) => {
  try {
    const num = figure
    const parts = num?.toString().split('.')
    return parts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  } catch (err) {
    console.log(err)
    return figure
  }
}

export const priceFormatter = (figure) => {
  try {
    const num = figure

    if (Number(num) === 0) return 'Gratis'

    const parts = num?.toString().split('.')
    return '$' + parts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  } catch (err) {
    console.log(err)
    return '$' + figure
  }
}
